import type { ComponentPropsWithoutRef, ReactNode } from "react";

export default function ButtonsGroup({
  children,
  align,
  ...htmlProps
}: ComponentPropsWithoutRef<"div"> & {
  align?: "start" | "center" | "end";
}): ReactNode {
  // https://getbootstrap.com/docs/4.0/components/button-group/
  return (
    <div className={`nav justify-content-${align ?? "end"}`} {...htmlProps}>
      <div className="buttons btn-group" role="group">
        {children}
      </div>
    </div>
  );
}
